import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import DashboardGenerale from "@/pages/DashboardGenerale";
import Commesse from "@/pages/Commesse";
import CommessaDetail from "@/pages/CommessaDetail";
import Anagrafica from "@/pages/Anagrafica";
import Magazzino from "@/pages/Magazzino";
import Prestazioni from "@/pages/Prestazioni";
import Preventivi from "@/pages/Preventivi";
import PreventivoDetail from "@/pages/PreventivoDetail";
import AccettaPreventivo from "@/pages/AccettaPreventivo";
import Utenti from "@/pages/Utenti";
import OreRapide from "@/pages/OreRapide";
import OreMensili from "@/pages/OreMensili";
import Cestino from "@/pages/Cestino";

function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Caricamento…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/accetta/:token" element={<AccettaPreventivo />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route
          path="/"
          element={<DashboardGenerale />}
        />
        <Route path="/commesse" element={<Commesse />} />
        <Route path="/commesse/:id" element={<CommessaDetail />} />
        <Route path="/ore-rapide" element={<OreRapide />} />
        <Route
          path="/ore-mensili"
          element={<OreMensili />}
        />
        <Route
          path="/anagrafica"
          element={<Anagrafica />}
        />
        <Route path="/magazzino" element={<Magazzino />} />
        <Route path="/prestazioni" element={<Prestazioni />} />
        <Route path="/prestazioni/:id" element={<CommessaDetail />} />
        <Route path="/preventivi" element={<Preventivi />} />
        <Route path="/preventivi/:id" element={<PreventivoDetail />} />
        <Route
          path="/cestino"
          element={<Cestino />}
        />
        <Route
          path="/utenti"
          element={<Utenti />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
